<template>
    <div>
    <h3 class="is-size-3">Claves Observacion Buro</h3>
        <p> <code>POST {{ host }}/api/bureauKeys/{bureauCode?}</code> </p>
        <br>
        <h5 class="is-size-6">El endpoint tiene un parametro opcional:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>bureauCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato (Ej. CC)</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br/>
        <h5 class="is-size-6">El endpoint recibe un token de seguridad en el header:</h5> 
        <pre>
        <code>headers: 
        { 
            "Authentication":"Bearer {TOKEN}",
        }</code>
        </pre>
        <br>
        <h5 class="is-size-6">Respuesta:</h5> 
        <pre>
        <code>[
            {
                "clave": "CC",
                "nombre": "Cuenta cancelada o cerrada",
                "aplicable_a": [],
                "renegotiation": false,
                "cancellation": true
            },
            {
                "clave": "IA",
                "nombre": "Cuenta inactiva",
                "aplicable_a": [],
                "renegotiation": false,
                "cancellation": true
            }
            ...
        ]</code>
        </pre>
        <hr />
       
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>

</style>